export const TOOL_TASK = 'send-welcome-email';
export const TOOL_TITLE = 'Send Welcome Email';
export const TOOL_PROGRESS_LABEL = 'Bulk welcome emails sending progress...';
export const FILE_NAME = 'Send-welcome-email-report';
export const TOOL_STACK_OVERFLOW_MESSAGE = 'Please try again once sending welcome emails finishes';
export const FILE_HEADERS = {
    userId: 'User Id',
    userEmail: 'User Email',
    actionStatus: 'Action Status',
};
